/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Layer} from 'baseui/layer'
import React, {createRef} from 'react'
import {Footer, FooterMobileMenu, FooterMobileMenuWrapper, Header, Helmet, Toaster} from '../app'

const layerRef = createRef()

const NoSidebarLayout = ({children}) => {
  return (
    <>
      <Helmet title="Secret of the Source Code" />
      <Block
        overrides={{
          Block: {
            style: {
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            },
          },
        }}
      >
        <Header />
        <Block
          overrides={{
            Block: {
              style: ({$theme}) => ({
                display: 'flex',
                flex: '1',
                justifyContent: 'center',
                backgroundColor: $theme.colors.primary50,
                paddingLeft: $theme.sizing.scale800,
                paddingRight: $theme.sizing.scale800,
                paddingTop: $theme.sizing.scale800,
              }),
            },
          }}
        >
          {children}
        </Block>
        <Footer alignCopyright="right" />
        <Layer>
          <FooterMobileMenuWrapper forwardedRef={layerRef}>
            <FooterMobileMenu />
          </FooterMobileMenuWrapper>
        </Layer>
        <Toaster />
      </Block>
    </>
  )
}

export default NoSidebarLayout
